import React from "react";
import classnames from "classnames";

import "./index.scss";

export interface LoaderProps {
  className?: string;
  text?: string;
}

const Loader: React.FC<LoaderProps> = ({ className, text }) => (
  <div className={classnames("loader", className)}>{text}</div>
);

export default Loader;
